import { Company } from '../company/company.model';
import { UserBasic } from '../../_models/user.model';
import { Injectable } from '@angular/core';
import { AttachmentImageThumbnail } from 'src/app/_models/image.model';

@Injectable()
export class Community {
  id: number;
  title: string; // tytuł news, eventu
  type: CommunityType; // 0 - news, 1 --event, 3 --board
  description: string; // dłuższy opis
  dateCreated: Date; // data datania wpisu
  publishDate: Date; // data datania wpisu
  idUserCreated: number; // id użytkownika który dodał
  startTime?: Date; // data rozpoczecia dla eventu
  endTime?: Date; // data zakończenia dla eventu
  localization?: string; // lokalizacja wydarzenia dla eventu
  idCompanyCreated: number; // firma która utworzyła
  companyCreated: Company; // join
  userCreated: UserBasic; //join User
  idBuilding?: number;
  image?: AttachmentImageThumbnail = new AttachmentImageThumbnail();
  additionalImages?: File[] = [];
  commentsCount?: number;
}

// zakładki
export enum CommunityType {
  Information = 1,
  Events = 2,
  Board = 3,
  IntegrationTrip = 101,
  GoodPracticesList = 102,
  Agenda = 103, // Added for agenda view post 
}

export class MarkNewsAsRead {
  ids: number[];
}
